import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const YourStayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-bottom: 20px;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;

  ${media.md`
    flex-direction: row;
    gap: 10px;
  `}
`;

export const YourStayLabel = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;

  ${media.md`
    margin-bottom: 0;
  `}
`;

export const YourStayDates = styled.span`
  font-size: 14px;
  color: #666;
`;
